var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { DAYS_PER_WEEK } from '../../DatePicker.constants';
import { Day } from '../Day';
import styles from './Week.module.css';
export const Week = ({ 'data-testid': testId, weekIndex }) => {
    return (_jsx("tr", { className: styles.Container, children: [...Array(DAYS_PER_WEEK).keys()].map((dayIndex) => {
            return (_jsx(Day, { "data-testid": testId, dayIndex: dayIndex, weekIndex: weekIndex }, `${weekIndex}-${dayIndex}`));
        }) }));
};
_react_refresh_temp_1 = Week;
$RefreshReg$(_react_refresh_temp_1, "Week");
